/* AFTER NOTE theme behaviour: AJAX cart drawer, mobile nav, PDP qty. */
(function () {
  var R = window.AN_ROUTES || { cart: '/cart', cartChange: '/cart/change', cartAdd: '/cart/add' };

  function $(s, r) { return (r || document).querySelector(s); }
  function money(cents) { return '₹' + Math.round(cents / 100).toLocaleString('en-IN'); }
  function initials(v) {
    return (v || '').replace(/[^A-Za-z& ]/g, '').split(' ').filter(Boolean).slice(0, 2)
      .map(function (s) { return s[0]; }).join('').toUpperCase();
  }
  function bottle(vendor) {
    var i = initials(vendor);
    return '<svg width="60" height="84" viewBox="0 0 120 168" fill="none" aria-hidden="true">' +
      '<rect x="48" y="6" width="24" height="16" fill="#0a0a0a"/>' +
      '<rect x="54" y="22" width="12" height="8" fill="#0a0a0a"/>' +
      '<rect x="26" y="30" width="68" height="126" rx="2" fill="none" stroke="#0a0a0a" stroke-width="1.3"/>' +
      '<rect x="36" y="78" width="48" height="54" fill="#0a0a0a" opacity="0.06"/>' +
      '<text x="60" y="112" text-anchor="middle" font-family="Bodoni Moda,serif" font-size="20" fill="#0a0a0a">' + i + '</text>' +
      '</svg>';
  }

  /* ---- drawer open/close ---- */
  function openCart() { var d = $('#drawer'), s = $('#scrim'); if (d) d.classList.add('open'); if (s) s.classList.add('open'); }
  function closeCart() { var d = $('#drawer'), s = $('#scrim'); if (d) d.classList.remove('open'); if (s) s.classList.remove('open'); }

  var tt;
  function toast(m) {
    var e = $('#toast'); if (!e) return;
    e.textContent = m; e.classList.add('show');
    clearTimeout(tt); tt = setTimeout(function () { e.classList.remove('show'); }, 1900);
  }

  /* ---- render cart from /cart.js ---- */
  function renderCart(cart) {
    var count = $('#cartCount'); if (count) count.textContent = cart.item_count;
    var wrap = $('#drawerItems'); var foot = $('#drawerFoot');
    if (!wrap) return;
    if (!cart.items.length) {
      wrap.innerHTML = '<div class="empty">Your cart is empty.<br>Discover. Indulge. Remember.</div>';
      if (foot) foot.innerHTML = '';
      return;
    }
    wrap.innerHTML = cart.items.map(function (it) {
      var vendor = it.vendor || '';
      var name = (it.product_title || it.title || '').replace(vendor, '').trim();
      var img = it.image
        ? '<img src="' + it.image + '" alt="" style="width:100%;height:100%;object-fit:contain">'
        : bottle(vendor);
      return '<div class="ci">' +
        '<div class="cithumb">' + img + '</div>' +
        '<div>' +
        '<div class="cibrand">' + vendor + '</div>' +
        '<div class="ciname">' + name + '</div>' +
        '<div class="ciprice">' + money(it.price) + '</div>' +
        '<div class="qty" style="margin-top:8px" data-key="' + it.key + '">' +
        '<button data-act="dec">−</button><span>' + it.quantity + '</span><button data-act="inc">+</button>' +
        '</div></div>' +
        '<button class="cirm" data-rm="' + it.key + '">Remove</button>' +
        '</div>';
    }).join('');
    if (foot) {
      foot.innerHTML =
        '<div class="stot"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>' +
        '<div class="ship">Free shipping on all orders</div>' +
        '<a href="/checkout" class="btn" style="width:100%">Proceed to Checkout</a>';
    }
  }

  function fetchCart(then) {
    fetch(R.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); if (then) then(c); })
      .catch(function () {});
  }

  function changeLine(key, qty) {
    fetch(R.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  /* ---- add to cart (cards + PDP) ---- */
  function bindAddForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('.js-add');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('button[type=submit]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
      var data = new FormData(form);
      fetch(R.cartAdd + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
        .then(function (r) { return r.json(); })
        .then(function () {
          fetchCart(function () { openCart(); });
          toast((form.getAttribute('data-name') || 'Item') + ' added');
        })
        .catch(function () { toast('Could not add. Try again.'); })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
    });
  }

  /* ---- delegated drawer controls ---- */
  function bindDrawer() {
    var items = $('#drawerItems');
    if (items) {
      items.addEventListener('click', function (e) {
        var inc = e.target.closest('[data-act]');
        var rm = e.target.closest('[data-rm]');
        if (inc) {
          var box = inc.closest('.qty'); var key = box.getAttribute('data-key');
          var cur = parseInt(box.querySelector('span').textContent, 10) || 1;
          changeLine(key, inc.getAttribute('data-act') === 'inc' ? cur + 1 : cur - 1);
        } else if (rm) {
          changeLine(rm.getAttribute('data-rm'), 0);
        }
      });
    }
    var t = $('#cartToggle'); if (t) t.addEventListener('click', function () { fetchCart(); openCart(); });
    var c = $('#cartClose'); if (c) c.addEventListener('click', closeCart);
    var s = $('#scrim'); if (s) s.addEventListener('click', closeCart);
  }

  /* ---- mobile nav ---- */
  function bindNav() {
    var b = $('#burger'); var m = $('#mobnav');
    if (b && m) b.addEventListener('click', function () { m.classList.toggle('open'); });
  }

  /* ---- PDP qty stepper ---- */
  function bindPdpQty() {
    var box = $('#pdpQty'); if (!box) return;
    var span = box.querySelector('span'); var input = $('#pdpQtyInput');
    box.addEventListener('click', function (e) {
      var act = e.target.getAttribute('data-act'); if (!act) return;
      var v = parseInt(span.textContent, 10) || 1;
      v = act === 'inc' ? v + 1 : Math.max(1, v - 1);
      span.textContent = v; if (input) input.value = v;
    });
  }

  /* ---- hero carousel ---- */
  function initHero() {
    var track = $('#heroTrack'); if (!track) return;
    var slides = [].slice.call(track.children);
    var dotsWrap = $('#heroDots'); var i = 0, timer = null;
    dotsWrap.innerHTML = slides.map(function (_, n) { return '<button aria-label="Slide ' + (n + 1) + '" class="' + (n === 0 ? 'on' : '') + '"></button>'; }).join('');
    var dots = [].slice.call(dotsWrap.children);
    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      slides.forEach(function (s) { s.classList.remove('is-active'); });
      void track.offsetWidth; slides[i].classList.add('is-active');
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    }
    function next() { go(i + 1); } function prev() { go(i - 1); }
    function start() { stop(); timer = setInterval(next, 5500); } function stop() { if (timer) clearInterval(timer); }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); start(); }); });
    var nx = $('#heroNext'), pv = $('#heroPrev');
    if (nx) nx.addEventListener('click', function () { next(); start(); });
    if (pv) pv.addEventListener('click', function () { prev(); start(); });
    var hero = track.closest('.hero');
    hero.addEventListener('mouseenter', stop); hero.addEventListener('mouseleave', start);
    var x0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 45) { dx < 0 ? next() : prev(); start(); } x0 = null; });
    go(0); start();
  }

  /* ---- scroll reveal (variants + staggered groups) ---- */
  function initScrollReveal() {
    var els = [].slice.call(document.querySelectorAll('.sr:not(.in), .sr-group:not(.in)'));
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); obs.unobserve(en.target); } }); 
    }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (e) { obs.observe(e); });
  }

  /* ---- product card image swap: hover on desktop, swipe on touch ---- */
  function initPcardMedia() {
    function slides(card) { return [].slice.call(card.querySelectorAll('.pcard-slide')); }

    function setSlide(card, idx) {
      var ss = slides(card); if (ss.length < 2) return;
      var n = ss.length;
      idx = ((idx % n) + n) % n;
      card.dataset.i = String(idx);
      ss.forEach(function (s, k) { s.classList.toggle('on', k === idx); });
      var dots = [].slice.call(card.querySelectorAll('.pcard-dots span'));
      dots.forEach(function (d, k) { d.classList.toggle('on', k === idx); });
    }

    /* Reels and the PDP thumb rail own their gestures entirely. The Most Loved
       track is different: there, only the card's image area owns the swipe and
       the rest of the card still scrolls the carousel. */
    function inScroller(card) { return !!card.closest('.reels-row, .pdp-thumbs'); }
    function inMostLoved(card) { return !!card.closest('.an-ml-track'); }

    /* --- desktop: hover shows the second image --- */
    if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      document.addEventListener('mouseover', function (e) {
        var c = e.target.closest && e.target.closest('[data-pcard-multi]');
        if (!c || (e.relatedTarget && c.contains(e.relatedTarget))) return;
        setSlide(c, 1);
      });
      document.addEventListener('mouseout', function (e) {
        var c = e.target.closest && e.target.closest('[data-pcard-multi]');
        if (!c || (e.relatedTarget && c.contains(e.relatedTarget))) return;
        setSlide(c, 0);
      });
    }

    /* --- touch: swipe across the card image --- */
    var active = null, sx = 0, sy = 0, moved = false;

    document.addEventListener('touchstart', function (e) {
      active = null;
      var c = e.target.closest && e.target.closest('[data-pcard-multi]');
      if (!c || inScroller(c)) return;

      /* the gesture must start on the image, never on the text below it */
      var thumb = c.querySelector('.pthumb');
      if (!thumb) return;
      var r = thumb.getBoundingClientRect();
      var x = e.touches[0].clientX, y = e.touches[0].clientY;
      if (x < r.left || x > r.right || y < r.top || y > r.bottom) return;

      active = c; moved = false;
      sx = x; sy = y;
    }, { passive: true });

    document.addEventListener('touchmove', function (e) {
      if (!active) return;
      var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
      if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) + 6) moved = true;
      /* horizontal drag on the image belongs to the image, not to the carousel.
         Vertical drags are left alone so the page still scrolls. */
      if (moved && e.cancelable) e.preventDefault();
    }, { passive: false });

    document.addEventListener('touchend', function (e) {
      if (!active) return;
      var card = active; active = null;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (!moved || Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
      var cur = parseInt(card.dataset.i || '0', 10);
      setSlide(card, dx < 0 ? cur + 1 : cur - 1);
      /* a swipe must not also open the product page */
      card.dataset.swiped = '1';
      setTimeout(function () { delete card.dataset.swiped; }, 450);
    }, { passive: true });

    document.addEventListener('click', function (e) {
      var c = e.target.closest && e.target.closest('[data-pcard-multi]');
      if (c && c.dataset.swiped) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    /* In Most Loved the image sits above .pcard-cover so it can own the swipe,
       which means a plain tap or click on it has to open the product itself. */
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var thumb = e.target.closest('.pthumb');
      if (!thumb || e.target.closest('.padd-form')) return;
      var card = thumb.closest('[data-pcard-multi]');
      if (!card || !inMostLoved(card) || card.dataset.swiped) return;
      var link = card.querySelector('.pcard-cover');
      if (link && link.href) window.location.href = link.href;
    });
  }

  /* ---- header auto-hide: hide on scroll down, reveal on scroll up ---- */
  function initHeaderAutoHide(header) {
    if (!header) return;

    var style = document.createElement('style');
    style.id = 'an-header-autohide';
    style.textContent =
      'header{transition:transform .38s cubic-bezier(.16,1,.3,1)!important;will-change:transform}' +
      'header.an-head-hidden{transform:translateY(-100%)!important}' +
      '@media(prefers-reduced-motion:reduce){header{transition:none!important}}';
    document.head.appendChild(style);

    var lastY = window.scrollY || 0;
    var REVEAL_ABOVE = 90;  /* always visible near the top of the page */
    var DELTA = 6;          /* ignore sub-pixel jitter and rubber-banding */
    var ticking = false;

    function locked() {
      /* never hide while an overlay that depends on the header is open */
      var d = document.getElementById('drawer');
      var m = document.getElementById('mobnav');
      var s = document.getElementById('searchov');
      return (d && d.classList.contains('open')) ||
             (m && m.classList.contains('open')) ||
             (s && s.classList.contains('open'));
    }

    function apply() {
      ticking = false;
      var y = window.scrollY || 0;

      if (locked()) { header.classList.remove('an-head-hidden'); lastY = y; return; }

      if (y <= REVEAL_ABOVE) {
        header.classList.remove('an-head-hidden');
      } else if (y > lastY + DELTA) {
        header.classList.add('an-head-hidden');      /* scrolling down */
      } else if (y < lastY - DELTA) {
        header.classList.remove('an-head-hidden');   /* scrolling up */
      }
      lastY = y;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(apply); }
    }, { passive: true });

    /* if focus lands on something inside the header, bring it back */
    header.addEventListener('focusin', function () { header.classList.remove('an-head-hidden'); });
    apply();
  }

  /* ---- header scroll state + announcement rotator ---- */
  function initChrome() {
    var header = document.querySelector('header');
    function onScroll() { if (header) header.classList.toggle('scrolled', window.scrollY > 20); }
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    initHeaderAutoHide(header);
    var ann = $('#announce');
    if (ann) {
      var msgs = [
        '100% Original · Free shipping on all orders · Authorised multi-brand house',
        'Arabian & Designer houses · 100% authentic bottles only',
        'Dispatched within 24 hours · 100% original bottles, always'
      ];
      var a = 0; ann.style.transition = 'opacity .4s';
      setInterval(function () { ann.style.opacity = '0'; setTimeout(function () { a = (a + 1) % msgs.length; ann.textContent = msgs[a]; ann.style.opacity = '1'; }, 400); }, 4200);
    }
  }

  /* ---- count up ---- */
  function animateCount(el) {
    var m = el.textContent.trim().match(/^(\d+)(.*)$/); if (!m) return;
    var target = parseInt(m[1], 10), suffix = m[2], dur = 1300, start = performance.now();
    (function step(t) { var p = Math.min(1, (t - start) / dur); el.textContent = Math.round((1 - Math.pow(1 - p, 3)) * target) + suffix; if (p < 1) requestAnimationFrame(step); })(start);
  }
  function initCounters() {
    var groups = document.querySelectorAll('.efacts'); if (!groups.length || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.querySelectorAll('.n').forEach(animateCount); obs.unobserve(e.target); } }); }, { threshold: .35 });
    groups.forEach(function (g) { obs.observe(g); });
  }

  /* ---- light parallax ---- */
  var parallaxEls = [];
  function initParallax() {
    parallaxEls = [].slice.call(document.querySelectorAll('[data-parallax]'));
    if (parallaxEls.length) onParallax();
  }
  function onParallax() {
    var vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      var r = el.getBoundingClientRect(); var speed = parseFloat(el.getAttribute('data-parallax')) || 0.1;
      var offset = (r.top + r.height / 2 - vh / 2) * -speed;
      el.style.transform = 'translate(-50%,calc(-50% + ' + offset.toFixed(1) + 'px))';
    });
  }
  window.addEventListener('scroll', function () { if (parallaxEls.length) requestAnimationFrame(onParallax); }, { passive: true });

  /* ---- shoppable reels horizontal scroll ---- */
  window.scrollReels = function (d) { var r = $('#reelsRow'); if (r) r.scrollBy({ left: d * Math.max(260, r.clientWidth * 0.8), behavior: 'smooth' }); };

  /* ---- search overlay (Shopify predictive search) ---- */
  function openSearch() { var o = $('#searchov'); if (!o) return; o.classList.add('open'); document.body.style.overflow = 'hidden'; var i = $('#searchInput'); doSearch(i.value); setTimeout(function () { i.focus(); }, 60); }
  function closeSearch() { var o = $('#searchov'); if (o) { o.classList.remove('open'); document.body.style.overflow = ''; } }
  window.openSearch = openSearch; window.closeSearch = closeSearch;
  var searchTimer = null;
  function doSearch(term) {
    term = (term || '').trim(); var box = $('#searchResults'); if (!box) return;
    if (!term) { box.innerHTML = '<div class="searchhint">Try a house or note — <b>Lattafa</b>, <b>Tom Ford</b>, <b>Oud</b>, <b>Armaf</b></div>'; return; }
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () {
      var url = '/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (data) {
        var items = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!items.length) { box.innerHTML = '<div class="searchhint">No matches for <b>' + term.replace(/[<>]/g, '') + '</b></div>'; return; }
        box.innerHTML = '<div class="searchhint"><b>' + items.length + '</b> result' + (items.length !== 1 ? 's' : '') + '</div>' +
          '<div class="pgrid sr-group in">' + items.map(searchCard).join('') + '</div>' +
          '<div style="text-align:center;margin-top:36px"><a class="btn" href="/search?q=' + encodeURIComponent(term) + '&type=product">View all results</a></div>';
      }).catch(function () { box.innerHTML = '<div class="searchhint">Search is unavailable right now.</div>'; });
    }, 200);
  }
  function searchCard(p) {
    var price = p.price ? ('₹' + Math.round(parseFloat(p.price)).toLocaleString('en-IN')) : '';
    var img = p.featured_image && p.featured_image.url ? '<div class="pthumb"><img src="' + p.featured_image.url + '" alt="" style="width:100%;height:100%;object-fit:contain"></div>' : '<div class="pthumb">' + bottle(p.vendor) + '</div>';
    var name = (p.title || '').replace(p.vendor || '', '').trim();
    return '<a class="pcard" href="' + p.url + '" style="display:block">' + img +
      '<div class="pmeta"><div class="pbrand">' + (p.vendor || '') + '</div><div class="pname">' + name + '</div>' +
      '<div class="prow"><span class="price">' + price + '</span></div></div></a>';
  }
  function bindSearch() {
    var i = $('#searchInput'); if (!i) return;
    i.addEventListener('input', function () { doSearch(this.value); });
    i.addEventListener('keydown', function (e) { if (e.key === 'Enter') { window.location.href = '/search?q=' + encodeURIComponent(this.value.trim()) + '&type=product'; } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindAddForms(); bindDrawer(); bindNav(); bindPdpQty(); bindSearch(); fetchCart();
    initHero(); initScrollReveal(); initChrome(); initCounters(); initParallax();
    initPcardMedia();
  });
})();
